module.exports = __webpack_public_path__ + "img/apps_14.1da4d711.jpg";